import React, { useEffect, useState } from "react";
import "../dashboard/Profile/section/Privacy_policy.css";
import { toastMessage } from "../../utils/toastMessage";
import { fetchCmsDataApi } from "../../services/faqs";
import { fetchPublicCmsDataApi } from "../../services/common";
import Footer from "../landingpage/section/Footer";
import Header from "../../components/header/Header";
import "../faqs/Faq_terms.css";

const Privacy = () => {
  const [privacyData, setPrivacyData] = useState("");

  const getAboutHandler = async () => {
    try {
      const { data } = await fetchPublicCmsDataApi({ type: "PRIVACY" });
      const { data: privacy, success, message } = data;
      if (success) {
        // toastMessage(message, "success", "privacy");
        setPrivacyData(privacy);
      }
    } catch (e) {
      console.log("Login:-", e.message);
    }
  };

  //   console.log(privacyData, "privacyData");

  useEffect(() => {
    getAboutHandler();
  }, []);

  return (
    <>
      <Header />

      <div className="Privacy_policy privacy_footer">
        <div className="container_privacy_policy">
          <div className="custom_container">

            <div className="privacy_policy_title">
              <h2>Privacy & Policy</h2>
            </div>

            <p
              dangerouslySetInnerHTML={{
                __html: privacyData?.description,
              }}
            ></p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Privacy;
